import { ArrowIcon, SparkIcon } from "../components/Icons";
import { PageHero } from "../components/PageHero";
import { BOOKING_URL, PHONE_DISPLAY, PHONE_HREF } from "../site";

export function SpecialsPage() {
  return (
    <>
      <PageHero
        eyebrow="Featured treatment"
        title="Your blowout, personalized."
        description="A customizable, same-day keratin treatment designed to support smoother, stronger, more manageable hair."
        image="/images/salon-hero.jpg"
        compact
      />
      <section className="section special-section">
        <div className="container special-grid">
          <div className="special-card">
            <SparkIcon />
            <p>Personalized Blowout™</p>
            <strong>Starting at $200</strong>
            <span>Includes a complimentary take-home product.</span>
          </div>
          <div className="special-copy">
            <p className="eyebrow">Keratin Complex</p>
            <h2>Condition. Strengthen. Revitalize.</h2>
            <p>Keratin is a protein found naturally in hair, skin, and nails. In hair, it acts as both a protective shield and an internal structural protein. It is one of the first things depleted by physical, chemical, and environmental damage.</p>
            <p>Keratin Complex treatments help condition, strengthen, revitalize, and repair the look of damage, supporting shine, elasticity, and a healthier appearance.</p>
            <div className="special-actions">
              <a className="button" href={BOOKING_URL} target="_blank" rel="noreferrer">Book a consultation <ArrowIcon /></a>
              <a className="text-link" href={PHONE_HREF}>Ask a stylist · {PHONE_DISPLAY}</a>
            </div>
            <small>Offer and pricing are subject to consultation, product availability, hair length, density, and treatment needs.</small>
          </div>
        </div>
      </section>
    </>
  );
}
